import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import MogamboResultBody from '../../../casinoComponents/refResultModal/MogamboResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';
import "./Result.css";

/**
 * Mogambo "Last Result" items in the reference markup (inside .casino-video-last-results):
 *   win 1 → <span class="resultb">W </span>, win 2 → <span class="resulta"> L</span>
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the reference result modal.
 * Last results are refetched when the round changes (reference: getLastResults on a new mid).
 */
const ResultMogambo = ({ data = [], gameData = {}, roundId }) => {
    const [lastResults, setLastResults] = useState([]);
    const [detailResult, setDetailResult] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const currentMid = roundId ?? gameData?.data?.data?.mid ?? gameData?.mid;

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) return;
        let cancelled = false;
        const fetchLastResults = async () => {
            try {
                const response = await getLastResults('mogambo');
                const res = response?.data?.data?.res;
                if (!cancelled && Array.isArray(res)) setLastResults(res);
            } catch (error) {
                console.error('Error fetching last results:', error);
            }
        };
        fetchLastResults();
        return () => { cancelled = true; };
    }, [data, currentMid]);

    const results = Array.isArray(data) && data.length > 0 ? data : lastResults;

    const handleResultClick = async (mid) => {
        if (!mid) return;
        setLoading(true);
        try {
            const response = await getDetailResults('mogambo', mid.toString());
            const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
            setDetailResult(t1 || null);
            setShowModal(!!t1);
        } catch (error) {
            console.error('Error fetching detail results:', error);
        }
        setLoading(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setDetailResult(null);
    };

    return (
        <>
            {results.map((r, index) => {
                const win = String(r?.win ?? '');
                return (
                    <span
                        key={r?.mid ?? index}
                        className={win === '1' ? 'resultb' : win === '2' ? 'resulta' : undefined}
                        onClick={() => handleResultClick(r?.mid)}
                    >
                        {win === '1' && 'W'}{' '}{win === '2' && 'L'}
                    </span>
                );
            })}
            {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
            <RefResultModal
                show={showModal && !loading && !!detailResult}
                onHide={handleCloseModal}
                title={`${detailResult?.ename || 'Mogambo'} Result`}
                roundId={detailResult?.rid}
                matchTime={formatRefMatchTime(detailResult?.mtime)}
            >
                <MogamboResultBody t1={detailResult} />
            </RefResultModal>
        </>
    );
};

export default ResultMogambo;
